// components/tmisc/onboarding/GetStarted.lib.catalogs.js
import l from "components/util/l";

// Helper para estandarizar { value, label }
const V = (s) => ({ value: s, label: s });

// Industrias (lista simple, sin objetos)
const INDUSTRIES = [
  l("Agroindustria / Alimentos%GS250"),
  l("Alimentos y Bebidas / Restaurantes%GS251"),
  l("Arte / Cultura%GS252"),
  l("Automotriz / Movilidad%GS253"),
  l("Banca y Finanzas / Fintech%GS254"),
  l("Bienes Raíces / Construcción%GS255"),
  l("Deportes / Fitness%GS256"),
  l("eCommerce / Marketplace%GS257"),
  l("Educación / EdTech%GS258"),
  l("Energía / Medio Ambiente%GS259"),
  l("Freelancers / Emprendedores%GS260"),
  l("Gobierno / Sector Público%GS261"),
  l("Legal / Compliance%GS262"),
  l("Logística / Transporte%GS263"),
  l("Manufactura%GS264"),
  l("Medios / Publicidad%GS266"),
  l("Moda / Belleza%GS267"),
  l("ONGs / Sector Social%GS268"),
  l("Recursos Humanos / Consultoría%GS269"),
  l("Retail / Comercio%GS270"),
  l("Salud y Bienestar%GS271"),
  l("Seguros y Pensiones%GS272"),
  l("Tecnología / Software%GS273"),
  l("Turismo y Hospitalidad%GS275"),
  // For whoever fits none of the above: the list is mandatory, so it needs a way out.
  l("Otra industria%GS925"),
];

// Base genérica (igual que tu base)
const BASE_PROCESSES = [
  { value: "reporting", label: l("Reportes / KPIs%GS042") },
  { value: "automation", label: l("Automatizaciones / Flujos%GS043") },
  { value: "documents", label: l("Documentos / Contratos%GS044") },
  { value: "integrations", label: l("Integraciones / API%GS045") },
  { value: "security", label: l("Seguridad / Accesos%GS046") },
  { value: "it_support", label: l("Soporte técnico / TI%GS047") },
  { value: "hr", label: l("Recursos Humanos / Nómina%GS048") },
  { value: "accounting", label: l("Contabilidad / Impuestos%GS049") },
  { value: "crm", label: l("Leads / CRM%GS050") },
  { value: "marketing", label: l("Marketing / Anuncios%GS051") },
];

// INDUSTRY_PROCESSES = sub-industrias por industria (chips del paso 1)
const INDUSTRY_PROCESSES = {
  [l("Agroindustria / Alimentos%GS250")]: [
    V(l("Control de Calidad%GS276")),
    V(l("Producción Agrícola / Ganadera%GS277")),
    V(l("Logística / Distribución%GS278")),
    V(l("Comercialización%GS279")),
    V(l("Innovación / AgroTech%GS280")),
    V(l("Finanzas%GS281")),
    V(l("Sustentabilidad%GS282")),
    V(l("RRHH%GS283")),
  ],
  [l("Alimentos y Bebidas / Restaurantes%GS251")]: [
    V(l("Compras / Proveedores%GS284")),
    V(l("Atención al Cliente%GS285")),
    V(l("Recursos Humanos%GS286")),
    V(l("Cocina / Producción%GS287")),
    V(l("Ventas / Reservas%GS288")),
    V(l("Marketing%GS289")),
    V(l("Administración / Finanzas%GS290")),
  ],
  [l("Arte / Cultura%GS252")]: [
    V(l("Producción / Exhibición%GS291")),
    V(l("Curaduría / Contenido%GS292")),
    V(l("Comunicación y Difusión%GS293")),
    V(l("Educación y Comunidad%GS294")),
    V(l("Administración%GS295")),
    V(l("Financiamiento / Patrocinios%GS296")),
    V(l("Tecnología y Medios Digitales%GS297")),
  ],
  [l("Automotriz / Movilidad%GS253")]: [
    V(l("Ingeniería y Producción%GS298")),
    V(l("Logística / Distribución%GS299")),
    V(l("Ventas y Posventa%GS300")),
    V(l("Marketing%GS301")),
    V(l("Servicio Técnico%GS302")),
    V(l("Finanzas%GS303")),
    V(l("RRHH%GS304")),
    V(l("Innovación / Nuevas Tecnologías%GS305")),
  ],
  [l("Banca y Finanzas / Fintech%GS254")]: [
    V(l("Marketing y Comunicación%GS306")),
    V(l("Atención al Cliente%GS307")),
    V(l("Crédito y Cobranza%GS308")),
    V(l("Riesgo y Cumplimiento%GS309")),
    V(l("Operaciones Bancarias%GS310")),
    V(l("Innovación y Productos%GS311")),
    V(l("Recursos Humanos%GS312")),
    V(l("Tecnología / IT%GS313")),
    V(l("Finanzas Corporativas%GS314")),
  ],
  [l("Bienes Raíces / Construcción%GS255")]: [
    V(l("Ventas / Comercialización%GS315")),
    V(l("Atención al Cliente%GS316")),
    V(l("Marketing%GS317")),
    V(l("Construcción / Proyectos%GS318")),
    V(l("Administración de Propiedades%GS319")),
    V(l("Finanzas / Inversión%GS320")),
    V(l("Jurídico%GS321")),
  ],
  [l("Deportes / Fitness%GS256")]: [
    V(l("Atención al Cliente%GS322")),
    V(l("Finanzas / Administración%GS323")),
    V(l("Operaciones de Club%GS324")),
    V(l("Marketing y Patrocinios%GS325")),
    V(l("Entrenamiento y Programas%GS326")),
    V(l("Tecnología / Wearables%GS327")),
    V(l("RRHH%GS328")),
  ],
  [l("eCommerce / Marketplace%GS257")]: [
    V(l("Adquisición de Clientes%GS329")),
    V(l("Marketing de Rendimiento%GS330")),
    V(l("Atención al Cliente%GS331")),
    V(l("Logística y Devoluciones%GS332")),
    V(l("Catálogo y Precios%GS333")),
    V(l("Análisis de Comportamiento%GS334")),
    V(l("Operaciones y Pagos%GS335")),
    V(l("Tecnología%GS336")),
  ],
  [l("Educación / EdTech%GS258")]: [
    V(l("Académico / Docencia%GS337")),
    V(l("Recursos Humanos%GS338")),
    V(l("Admisiones%GS339")),
    V(l("Comunicación Institucional%GS340")),
    V(l("Administración y Pagos%GS341")),
    V(l("Tecnología Educativa%GS342")),
    V(l("Evaluación y Seguimiento%GS343")),
    V(l("Vinculación / Relaciones Públicas%GS344")),
  ],
  [l("Energía / Medio Ambiente%GS259")]: [
    V(l("Logística y Distribución%GS345")),
    V(l("Producción y Operaciones%GS346")),
    V(l("Ingeniería%GS347")),
    V(l("Cumplimiento Ambiental%GS348")),
    V(l("Seguridad%GS349")),
    V(l("Innovación / Sostenibilidad%GS350")),
    V(l("Administración y Finanzas%GS351")),
    V(l("RRHH%GS352")),
  ],
  [l("Freelancers / Emprendedores%GS260")]: [
    V(l("Marketing Personal%GS353")),
    V(l("Gestión de Proyectos%GS354")),
    V(l("Finanzas / Facturación%GS355")),
    V(l("Atención a Clientes%GS356")),
    V(l("Innovación / Desarrollo de Servicios%GS357")),
    V(l("Comunicación%GS358")),
  ],
  [l("Gobierno / Sector Público%GS261")]: [
    V(l("Recursos Humanos%GS359")),
    V(l("Atención Ciudadana%GS360")),
    V(l("Comunicación Institucional%GS361")),
    V(l("Finanzas Públicas%GS362")),
    V(l("Transparencia / Datos Abiertos%GS363")),
    V(l("Planeación y Evaluación%GS364")),
    V(l("Tecnología / Sistemas%GS365")),
    V(l("Educación y Salud Pública%GS366")),
  ],
  [l("Legal / Compliance%GS262")]: [
    V(l("Asesoría Jurídica%GS367")),
    V(l("Contratos%GS368")),
    V(l("Cumplimiento Normativo%GS369")),
    V(l("Propiedad Intelectual%GS370")),
    V(l("Litigio / Casos%GS371")),
    V(l("Operaciones Legales%GS372")),
    V(l("Administración / Facturación%GS373")),
    V(l("Tecnología Legal (LegalTech)%GS374")),
  ],
  [l("Logística / Transporte%GS263")]: [
    V(l("Atención al Cliente%GS375")),
    V(l("Compras / Proveedores%GS376")),
    V(l("Planeación y Rutas%GS377")),
    V(l("Control de Flota%GS378")),
    V(l("Almacenamiento%GS379")),
    V(l("Seguimiento de Envíos%GS380")),
    V(l("Tecnología / Monitoreo%GS381")),
    V(l("Administración%GS382")),
  ],
  [l("Manufactura%GS264")]: [
    V(l("Producción%GS383")),
    V(l("Control de Calidad%GS384")),
    V(l("Ingeniería y Mantenimiento%GS385")),
    V(l("Logística y Distribución%GS386")),
    V(l("Compras / Proveedores%GS387")),
    V(l("Seguridad Industrial%GS388")),
    V(l("Recursos Humanos%GS389")),
    V(l("Finanzas y Planeación%GS390")),
  ],
  [l("Medios / Publicidad%GS266")]: [
    V(l("Producción / Contenido%GS395")),
    V(l("Creatividad%GS396")),
    V(l("Marketing y Medios%GS397")),
    V(l("Ventas de Publicidad%GS398")),
    V(l("Relaciones Públicas%GS399")),
    V(l("Administración / Finanzas%GS400")),
    V(l("Tecnología (Plataformas / Streaming)%GS401")),
    V(l("Talento y RRHH%GS402")),
  ],
  [l("Moda / Belleza%GS267")]: [
    V(l("Marketing y Comunicación%GS403")),
    V(l("Recursos Humanos%GS404")),
    V(l("Producción / Proveedores%GS405")),
    V(l("Ventas / Retail%GS406")),
    V(l("eCommerce%GS407")),
    V(l("Relaciones Públicas%GS408")),
    V(l("Finanzas%GS409")),
  ],
  [l("ONGs / Sector Social%GS268")]: [
    V(l("Recursos Humanos%GS410")),
    V(l("Programas y Proyectos%GS411")),
    V(l("Recaudación de Fondos%GS412")),
    V(l("Comunicación y Marketing%GS413")),
    V(l("Alianzas Estratégicas%GS414")),
    V(l("Administración y Finanzas%GS415")),
    V(l("Evaluación de Impacto%GS416")),
  ],
  [l("Recursos Humanos / Consultoría%GS269")]: [
    V(l("Reclutamiento%GS417")),
    V(l("Onboarding%GS418")),
    V(l("Desarrollo Organizacional%GS419")),
    V(l("Evaluación y Capacitación%GS420")),
    V(l("Comunicación Interna%GS421")),
    V(l("Nómina y Compensaciones%GS422")),
    V(l("Innovación y Consultoría Estratégica%GS423")),
  ],
  [l("Retail / Comercio%GS270")]: [
    V(l("Ventas%GS424")),
    V(l("Marketing y Fidelización%GS425")),
    V(l("Operaciones%GS426")),
    V(l("Logística y Distribución%GS427")),
    V(l("Servicio al Cliente%GS428")),
    V(l("Compras y Abastecimiento%GS429")),
    V(l("Análisis de Datos%GS430")),
    V(l("eCommerce / Digital%GS431")),
    V(l("Recursos Humanos%GS432")),
  ],
  [l("Salud y Bienestar%GS271")]: [
    V(l("Recursos Humanos%GS433")),
    V(l("Atención Médica%GS434")),
    V(l("Administración y Finanzas%GS435")),
    V(l("Tecnología / Sistemas Médicos%GS436")),
    V(l("Comunicación con Pacientes%GS437")),
    V(l("Compras / Suministros Médicos%GS438")),
    V(l("Investigación y Desarrollo%GS439")),
    V(l("Marketing de Servicios%GS440")),
  ],
  [l("Seguros y Pensiones%GS272")]: [
    V(l("Suscripción y Evaluación de Riesgo%GS441")),
    V(l("Atención al Cliente%GS442")),
    V(l("Siniestros%GS443")),
    V(l("Ventas y Corretaje%GS444")),
    V(l("Cumplimiento Normativo%GS445")),
    V(l("Marketing y Promoción%GS446")),
    V(l("Tecnología y Datos%GS447")),
    V(l("Recursos Humanos%GS448")),
  ],
  [l("Tecnología / Software%GS273")]: [
    V(l("Desarrollo de Producto%GS449")),
    V(l("Ingeniería / IT%GS450")),
    V(l("Soporte Técnico%GS451")),
    V(l("Ventas (B2B / B2C)%GS452")),
    V(l("Marketing%GS453")),
    V(l("Customer Success%GS454")),
    V(l("Recursos Humanos%GS455")),
    V(l("Operaciones%GS456")),
    V(l("Finanzas%GS457")),
    V(l("Innovación%GS458")),
  ],
  [l("Turismo y Hospitalidad%GS275")]: [
    V(l("Recursos Humanos%GS460")),
    V(l("Reservas y Ventas%GS461")),
    V(l("Atención al Huésped%GS462")),
    V(l("Marketing%GS463")),
    V(l("Administración%GS464")),
    V(l("Operaciones / Mantenimiento%GS465")),
    V(l("Alimentos y Bebidas%GS466")),
    V(l("Eventos y Experiencias%GS467")),
  ],
};

export { INDUSTRIES, INDUSTRY_PROCESSES, BASE_PROCESSES };
